import axios from 'axios'
import {
	encryptLong,
	syShopSign
} from '@/utils/rsaEncrypt'

// 创建axios实例
const service = axios.create({
	baseURL: '/api', // 本地开发走代理，统一写 /api
	timeout: 10000 // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
	config => {
		let timeStamp = new Date().getTime()
		let nonce = Math.floor(1000000 + Math.random() * 9000000); // 7位随机数
		let sySign = syShopSign()
		let CheckCsrf = encryptLong(sySign + timeStamp + nonce)

		// 请求头
		config.headers['TimeStamp'] = timeStamp
		config.headers['CheckCsrf'] = CheckCsrf
		config.headers['nonce'] = nonce;
		config.headers['Content-Type'] = 'application/json'

		return config;
	},
	error => {
		console.error("请求错误:", error);
		return Promise.reject(error);
	}
);

// 响应拦截器
service.interceptors.response.use(
	response => {
		const res = response.data;
		// 根据后端实际返回状态码修改
		if (res.code !== 200 && res.status !== 200) {
			return Promise.reject(res.msg || '请求失败');
		}
		return res;
	},
	error => {
		console.error("响应错误:", error);
		return Promise.reject(error);
	}
);

export default service;


// WEBPACK FOOTER //
// ./src/utils/util.js